var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonControl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -32,
    y: -32,
    width: 104,
    height: 104
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(16px)",
      clipPath: "url(#bgblur_0_6053_22175_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 32
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6053_22175",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40V38C10.0589 38 2 29.9411 2 20H0H-2C-2 32.1503 7.84974 42 20 42V40ZM40 20H38C38 29.9411 29.9411 38 20 38V40V42C32.1503 42 42 32.1503 42 20H40ZM20 0V2C29.9411 2 38 10.0589 38 20H40H42C42 7.84974 32.1503 -2 20 -2V0ZM20 0V-2C7.84974 -2 -2 7.84974 -2 20H0H2C2 10.0589 10.0589 2 20 2V0Z",
    fill: "#1E1E1E",
    mask: "url(#path-1-inside-1_6053_22175)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6053_22175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3981 29.7427C15.08 29.4101 15.0917 28.8826 15.4243 28.5645L24.3781 20L15.4243 11.4355C15.0917 11.1174 15.08 10.5899 15.3981 10.2573C15.7163 9.92473 16.2438 9.91301 16.5763 10.2311L26.1597 19.3978C26.324 19.555 26.417 19.7726 26.417 20C26.417 20.2274 26.324 20.445 26.1597 20.6022L16.5763 29.7689C16.2438 30.087 15.7163 30.0753 15.3981 29.7427Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_6053_22175_clip_path",
    transform: "translate(32 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6053_22175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonControl);
export default __webpack_public_path__ + "static/media/button-control.7ecb6b975603f59fb62b9221d07ff814.svg";
export { ForwardRef as ReactComponent };